import AppHeader from '../AppHeader'

//
// 書類更新の確認画面
//
export default {
  name: 'document-renewal-detail',
  created () {
    if (!this.canReview) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      deadline_date: null,
      review_comment: '',
      saving: false
    }
  },
  computed: {
    renewal () {
      return this.$store.getters.documentRenewal
    },
    forbidden () {
      return this.$store.getters.documentRenewalForbidden
    },
    notify () {
      return this.$store.getters.documentRenewalNotify
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    canReview () {
      return this.isShopMaster || this.isClerk || this.isSystemManagement
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    fileUrl () {
      if (!this.renewal) return ''
      return this.renewal.attributes['file-url'] + '?token=' + this.authToken
    },
    statusClass () {
      if (!this.renewal) return 'label-default'
      var status = this.renewal.attributes['status']
      if (status === 'submitted') return 'label-warning'
      if (status === 'confirmed') return 'label-success'
      if (status === 'rejected') return 'label-danger'
      return 'label-default'
    },
    backPage () {
      return window.sessionStorage.getItem('BackPage') || '/document_renewals'
    },
    backPageLabel () {
      return this.backPage === '/deadline_notices' ? this.$t('Deadline Notice') : this.$t('Document Renewal List')
    },
    // 既存 user-pdf.js の *_end_date と同じ yyyy-mm-dd 変換
    deadline_end_date () {
      return this.deadline_date ? this.deadline_date.getFullYear() + '-' + ('0' + (this.deadline_date.getMonth() + 1)).slice(-2) + '-' + ('0' + this.deadline_date.getDate()).slice(-2) : ''
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_DOCUMENT_RENEWAL', {id: this.$route.params.id, callback: callback})
    },
    confirm: function () {
      if (this.saving) return
      var hiduke = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
      if (!hiduke.test(this.deadline_end_date)) {
        window.alert(this.$t('document_renewal.message.date_required'))
        return
      }
      if (!window.confirm(this.$t('document_renewal.message.confirm_alert'))) {
        return
      }
      var self = this
      this.saving = true
      var callback = function () {
        self.deadline_date = null
        self.search()
      }
      this.$store.dispatch('CONFIRM_DOCUMENT_RENEWAL', {
        id: this.$route.params.id,
        data: {dead_line_date: this.deadline_end_date},
        callback: callback
      }).then(() => { self.saving = false }).catch(() => { self.saving = false })
    },
    reject: function () {
      if (this.saving) return
      if (!this.review_comment || this.review_comment.trim() === '') {
        window.alert(this.$t('document_renewal.message.comment_required'))
        return
      }
      if (!window.confirm(this.$t('document_renewal.message.reject_alert'))) {
        return
      }
      var self = this
      this.saving = true
      var callback = function () {
        self.review_comment = ''
        self.search()
      }
      this.$store.dispatch('REJECT_DOCUMENT_RENEWAL', {
        id: this.$route.params.id,
        data: {review_comment: this.review_comment},
        callback: callback
      }).then(() => { self.saving = false }).catch(() => { self.saving = false })
    },
    goBack: function () {
      this.$router.push({ path: this.backPage })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/document-renewal-detail.js